import { render } from "./App.vue?vue&type=template&id=5566511c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5566511c&lang=less"

import exportComponent from "/var/www/chc-chat/mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__